import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgButtonRefreshArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "button-refresh-arrow" }),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "6 14.248 6 18.748 1.5 18.748"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.717,18.751A9.753,9.753,0,0,1,16.5,3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.712,18.746A9.72,9.72,0,1,1,9,21"
		})
	]
});
export default SvgButtonRefreshArrow;
